import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Task } from './task.interface';

const TASK_INCLUDES = ['taskType', 'createdByUser', 'assignedUser', 'assignedByUser', 'completedByUser', 'users'];

export class TaskService {
   async getTasks(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Task>>>(`/tasks`, { params: { ...query } });
      return response.data;
   }

   async createTask(task: Task) {
      const response = await http.post<ApiResource<Task>>(`/tasks`, task, {
         params: { include: TASK_INCLUDES.join(','), append: 'taskable' },
      });
      return response.data;
   }

   async putTask(task: Task, id: number) {
      const response = await http.put<ApiResource<Task>>(`/tasks/${id}`, task, {
         params: { include: TASK_INCLUDES.join(','), append: 'taskable' },
      });
      return response.data;
   }

   async patchTask(taskId: number, path: keyof Task, value: string | number) {
      const response = await http.patch<ApiResource<Task>>(`/tasks/${taskId}`, {
         [path]: value,
      });
      return response.data;
   }

   async completeTask(taskId: number) {
      const response = await http.post<ApiResource<Task>>(`/tasks/${taskId}/complete`);
      return response.data;
   }

   async bulkCompleteTasks(taskIds: number[], completedByUserId?: number, completedAt?: string) {
      const response = await http.post<ApiResource<Array<Task>>>(`/tasks/bulk-complete`, {
         task_ids: taskIds,
         completed_by_user_id: completedByUserId,
         completed_at: completedAt,
      });

      return response.data;
   }

   async incompleteTask(taskId: number) {
      const response = await http.post<ApiResource<Task>>(`/tasks/${taskId}/incomplete`, {
         append: 'taskable',
         include: TASK_INCLUDES.join(','),
      });
      return response.data;
   }
}
